import PutioAPIClient from "@putdotio/api-client";

import { getAppInfo } from "./utils";

export const apiClient = new PutioAPIClient({
  clientID: getAppInfo().id,
});

export const getAPIClient = () => apiClient;
